import { api } from "@/builders/axios";

type SetupQuestionBanks = {
  title: string;
  subject_id: number;
  topic_id: number;
};

const get = function (id: number) {
  return api.get<SetupQuestionBanks>(`/setup/question-banks/${id}`);
};

const put = function (id: number, data: SetupQuestionBanks) {
  return api.put(`/setup/question-banks/${id}`, data);
};

const patch = function (id: number, data: Partial<SetupQuestionBanks>) {
  return api.patch(`/setup/question-banks/${id}`, data);
};

const del = function (id: number) {
  return api.delete(`/setup/question-banks/${id}`);
};

export const id = {
  get,
  put,
  patch,
  del,
};
